
const LandscapingHero = () => {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary to-primary-dark">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/ca335ea37b31607838cd36add0c19c6b.jpg)',
        }}
      ></div>
      <div className="container mx-auto px-6 relative z-10">
        <nav className="text-white/80 mb-6 text-sm">
          <a href="/" className="hover:text-white cursor-pointer">Home</a>
          <span className="mx-2">/</span>
          <span className="text-white">Landscaping Services</span>
        </nav>
        <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-6">
          Professional Landscaping Services
        </h1>
        <p className="text-xl text-white/90 max-w-2xl mb-8">
          Transform your outdoor space with Look Who's Landscaping. Expert garden design, maintenance, clean-ups, and compost delivery across Durban and KwaZulu-Natal.
        </p>
        <a
          href="https://wa.me/27798768956"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-primary px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line mr-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
          Get Free Quote
        </a>
      </div>
    </section>
  );
};

export default LandscapingHero;
